import {
    Language,
    ProductToLanguageListMapServerEntry
} from '../shared/Language.model';
import { LanguageServer } from '../shared/LanguagesApi.serverinterface';

export class LanguagesTransformersShared {
    transformLanguage(
        server: LanguageServer | ProductToLanguageListMapServerEntry
    ): Language {
        return LanguagesTransformersShared.transformLanguage(server);
    }

    static transformLanguage(
        server: LanguageServer | ProductToLanguageListMapServerEntry
    ): Language {
        return new Language({
            display: server.localizedName,
            locale: server.languageLocaleCode,
            drupalCode: server.drupalCode
        });
    }
}
